import fetch from 'isomorphic-fetch';
import { saveAs } from 'file-saver'

const checkStatus = (response) => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        let error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
};

const parseJson = response => response.json();

class ApiService {
    constructor(){}

    init(baseUrl, auth0Service){
        this.baseUrl = baseUrl;
        this.auth0Service = auth0Service;
    }

    setToken(token){
        this.token = token;
    }

    getToken(){
        return this.auth0Service.getToken();
    }

    request({ url, method, payload, onPayload, parse, onResult}) {
        const fetchUrl = `${this.baseUrl}${url}`;
        let options = {
            method,
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.getToken()}`
            }
        };
        if (payload) options.body = JSON.stringify(onPayload ? onPayload(payload) : payload);

        let promise = fetch(fetchUrl, options).then(checkStatus);
        if (parse) {
            return promise.then(parseJson).then(json => onResult ? onResult(json) : json);
        }

        return promise;
    }

    requestFile({ url, method, filename}) {
        const fetchUrl = `${this.baseUrl}${url}`;
        let options = {
            method,
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
                'Content-Type': 'application/pdf',
                'Authorization': `Bearer ${this.getToken()}`
            },
            responseType: 'blob'
        };
        
       return fetch(fetchUrl, options).then(response => response.blob()).then(blob => saveAs(blob, filename));
    }
}

export default ApiService;